import Palette from '@mui/icons-material/Palette'
import iconsUrl from './config/iconsUrl.json'
import {IconBase, IconProps, getIconClassName} from './IconBase'
import {makeStyles} from '@oc/styles'

const useDefaultStyles = makeStyles({
    rotateRight: {
        transform: 'rotate(90deg)'
    },
    rotateDown: {
        transform: 'rotate(180deg)'
    },
    rotateLeft: {
        transform: 'rotate(270deg)'
    }
})

// Basic actions
export const AddIcon = (props: IconProps) => <IconBase url={iconsUrl.add} {...props} />
export const ArrowThinIcon = (props: IconProps) => <IconBase url={iconsUrl.oc_arrow_thin} {...props} />
export const CancelCircleIcon = (props: IconProps) => <IconBase url={iconsUrl.cancel_circle} {...props} />
export const CancelIcon = (props: IconProps) => <IconBase url={iconsUrl.cancel} {...props} />
export const DeleteIcon = (props: IconProps) => <IconBase url={iconsUrl.trash} {...props} />
export const DeleteCircleIcon = (props: IconProps) => <IconBase url={iconsUrl.deduct} {...props} />
export const DownloadIcon = (props: IconProps) => <IconBase url={iconsUrl.download} {...props} />
export const EditIcon = (props: IconProps) => <IconBase url={iconsUrl.edit} {...props} />
export const ImportIcon = (props: IconProps) => <IconBase url={iconsUrl.import} {...props} />
export const SearchIcon = (props: IconProps) => <IconBase url={iconsUrl.search} {...props} />
export const SaveIcon = (props: IconProps) => <IconBase url={iconsUrl.save} {...props} />
export const OpenDialogIcon = (props: IconProps) => <IconBase url={iconsUrl.openDialog} {...props} />
export const LogoutIcon = (props: IconProps) => <IconBase url={iconsUrl.logout} {...props} />

// Other actions
export const AlarmIcon = (props: IconProps) => <IconBase url={iconsUrl['demo-trigger']} {...props} />
export const AttachmentIcon = (props: IconProps) => <IconBase url={iconsUrl.paperclip} {...props} />
export const CopyIcon = (props: IconProps) => <IconBase url={iconsUrl.copy} {...props} />
export const CommentIcon = (props: IconProps) => <IconBase url={iconsUrl.performance_comment} {...props} />
export const ExportPdfIcon = (props: IconProps) => <IconBase url={iconsUrl.pdfExport} {...props} />
export const ExportCsvIcon = (props: IconProps) => <IconBase url={iconsUrl.csvExport} {...props} />
export const ExportXlsIcon = (props: IconProps) => <IconBase url={iconsUrl.excelExport} {...props} />
export const LanguageIcon = (props: IconProps) => <IconBase url={iconsUrl.language} {...props} />
export const PauseIcon = (props: IconProps) => <IconBase url={iconsUrl.nonproductive} {...props} />
export const RefreshIcon = (props: IconProps) => <IconBase url={iconsUrl.refresh} {...props} />
export const SettingsIcon = (props: IconProps) => <IconBase url={iconsUrl.settings} {...props} />
export const StartIcon = (props: IconProps) => <IconBase url={iconsUrl.start} {...props} />
export const StopIcon = (props: IconProps) => <IconBase url={iconsUrl.states_stateInactive} {...props} />
export const VisibilityOnIcon = (props: IconProps) => <IconBase url={iconsUrl.observation} {...props} />
export const VisibilityOffIcon = (props: IconProps) => <IconBase url={iconsUrl.nonObservance} {...props} />
export const FilterIcon = (props: IconProps) => <IconBase url={iconsUrl.filter} {...props} />
export const LinkIcon = (props: IconProps) => <IconBase url={iconsUrl.link} {...props} />
export const ContextMenuIcon = (props: IconProps) => <IconBase url={iconsUrl.context_menu} {...props} />
export const LockIcon = (props: IconProps) => <IconBase url={iconsUrl.protection} {...props} />
export const S2AIcon = (props: IconProps) => <IconBase url={iconsUrl['brand-mobile_just_image']} {...props} />
export const QRIcon = (props: IconProps) => <IconBase url={iconsUrl.qrIcon} {...props} />
export const ExpandIcon = (props: IconProps) => <IconBase url={iconsUrl['expand-more']} {...props} />
export const DeploymentIcon = (props: IconProps) => <IconBase url={iconsUrl.oc_deployment} {...props} />
export const MassDeploymentIcon = (props: IconProps) => <IconBase url={iconsUrl['oc_rk-mass-deployment']} {...props} />
export const DataLoadingIcon = (props: IconProps) => <IconBase url={iconsUrl['data-loading']} {...props} />
export const DecommissioningIcon = (props: IconProps) => <IconBase url={iconsUrl.oc_decommissioning} {...props} />
export const CloudUploadIcon = (props: IconProps) => <IconBase url={iconsUrl['cloud-upload']} {...props} />

// Display icons
export const CalendarIcon = (props: IconProps) => <IconBase url={iconsUrl.calendar} {...props} />
export const CheckIcon = (props: IconProps) => <IconBase url={iconsUrl.check} {...props} />
export const InfoIcon = (props: IconProps) => <IconBase url={iconsUrl.info} {...props} />
export const ListIcon = (props: IconProps) => <IconBase url={iconsUrl['watchdog_tabs_watches']} {...props} />
export const PinIcon = (props: IconProps) => <IconBase url={iconsUrl.pin} {...props} />
export const PlaceMarkerIcon = (props: IconProps) => <IconBase url={iconsUrl.placeMarking} {...props} />
export const WarningCircleIcon = (props: IconProps) => <IconBase url={iconsUrl.normal_prio_task} {...props} />
export const WarningHighIcon = (props: IconProps) => <IconBase url={iconsUrl.high_prio_task} {...props} />
export const WarningTriangleIcon = (props: IconProps) => <IconBase url={iconsUrl.states_stateAlarm} {...props} />
export const ClockIcon = (props: IconProps) => <IconBase url={iconsUrl.watchdog_data_livegraph} {...props} />
export const PersonnelIcon = (props: IconProps) => <IconBase url={iconsUrl.personnel} {...props} />
export const PlusIcon = (props: IconProps) => <IconBase url={iconsUrl.plus} {...props} />
export const QualityIcon = (props: IconProps) => <IconBase url={iconsUrl.quality} {...props} />
export const SquareInfoIcon = (props: IconProps) => <IconBase url={iconsUrl['square-info']} {...props} />
export const FavoriteIcon = (props: IconProps) => <IconBase url={iconsUrl.oc_favorite} {...props} />
export const FavoriteFilledIcon = (props: IconProps) => <IconBase url={iconsUrl.oc_favorite_filled} {...props} />
export const FavoriteSmallIcon = (props: IconProps) => <IconBase url={iconsUrl['favorite-small']} {...props} />
export const EnvelopIcon = (props: IconProps) => <IconBase url={iconsUrl.envelop} {...props} />
export const KeyIcon = (props: IconProps) => <IconBase url={iconsUrl.key} {...props} />
export const BookmarkIcon = (props: IconProps) => <IconBase url={iconsUrl.bookmark} {...props} />
export const UnlockedIcon = (props: IconProps) => <IconBase url={iconsUrl.unlocked} {...props} />
export const ThemeStackIcon = (props: IconProps) => <IconBase url={iconsUrl['theme-stack']} {...props} />
export const DashboardIcon = (props: IconProps) => <IconBase url={iconsUrl.dashboard} {...props} />
export const DescriptionIcon = (props: IconProps) => <IconBase url={iconsUrl.description} {...props} />
export const SourceBranchIcon = (props: IconProps) => <IconBase url={iconsUrl['source-branch']} {...props} />
export const PlayListCheckIcon = (props: IconProps) => <IconBase url={iconsUrl['playlist-check']} {...props} />
export const ListBoxOutlineIcon = (props: IconProps) => <IconBase url={iconsUrl['list-box-outline']} {...props} />
export const FileIcon = (props: IconProps) => <IconBase url={iconsUrl.file} {...props} />
export const FileManageIcon = (props: IconProps) => <IconBase url={iconsUrl['file-manage']} {...props} />
export const AccountRkPropertiesIcon = (props: IconProps) => (
    <IconBase url={iconsUrl['oc_account-rk-properties']} {...props} />
)
export const CloudOffOutlineIcon = (props: IconProps) => <IconBase url={iconsUrl['cloud-off-outline']} {...props} />

// Navigation icons
export const ArrowIcon = (props: IconProps) => <IconBase url={iconsUrl.navigationArrow} {...props} />
export const ArrowHeavyIcon = (props: IconProps) => <IconBase url={iconsUrl.navigationArrowHeavy} {...props} />
export const DoubleArrowRightIcon = (props: IconProps) => <IconBase url={iconsUrl.double_arrow_right} {...props} />
export const DoubleArrowLeftIcon = (props: IconProps) => <IconBase url={iconsUrl.double_arrow_left} {...props} />
export const ArrowFilledIcon = (props: IconProps) => <IconBase url={iconsUrl['motion-right']} {...props} />

// Equipment basic
export const EnterpriseIcon = (props: IconProps) => <IconBase url={iconsUrl['equipment_eq-enterprise']} {...props} />
export const EquipmentIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment} {...props} />
export const LineIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment_line} {...props} />
export const PlantIcon = (props: IconProps) => <IconBase url={iconsUrl['equipment_eq-plant']} {...props} />
export const ReadyKitIcon = (props: IconProps) => <IconBase url={iconsUrl.watchdog_datapoints_readykit} {...props} />
export const AreaIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment_area} {...props} />
export const MachineIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment_machine} {...props} />
export const MachineGroupIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment_machineGroup} {...props} />
export const ComponentIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment_component} {...props} />
export const SubsidiaryIcon = (props: IconProps) => <IconBase url={iconsUrl.equipment_subsidiary} {...props} />

// Logos
export const KronesLogo = (props: IconProps) => <IconBase url={iconsUrl.kronesLogo} {...props} />
export const KronesMark = (props: IconProps) => <IconBase url={iconsUrl.krones_mark} {...props} />
export const SyskronLogo = (props: IconProps) => <IconBase url={iconsUrl.syskronLogo} {...props} />
export const OperationsConsoleLogo = (props: IconProps) => (
    <IconBase url={iconsUrl['oc_operations-console']} {...props} />
)

// S2A Services
export const PerformanceIcon = (props: IconProps) => <IconBase url={iconsUrl.performance} {...props} />
export const WatchdogIcon = (props: IconProps) => <IconBase url={iconsUrl.watchdog} {...props} />
export const ConnectIcon = (props: IconProps) => <IconBase url={iconsUrl.connect} {...props} />
export const TaskServiceIcon = (props: IconProps) => <IconBase url={iconsUrl['task-service']} {...props} />

// Reused material UI icons
export const PaletteIcon = (props: IconProps) => {
    const {classes, cx} = useDefaultStyles()
    return (
        <Palette
            color={props.color}
            htmlColor={props.htmlColor}
            className={cx(props.className, getIconClassName(classes, props.rotate))}
            style={props.fontSize ? {fontSize: props.fontSize} : undefined}
        />
    )
}
